import * as THREE from "three";
import { WORLD } from "../config";
import { harbourWaterSdf } from "../coast";
import type { ClubMaterials } from "../materials";

const LAND_TOP = 1.82;

export function buildIsland(mats: ClubMaterials): THREE.Group {
  const g = new THREE.Group();
  g.name = "island";

  const clubLawn = new THREE.Mesh(new THREE.BoxGeometry(56, 0.12, 20), mats.grass);
  clubLawn.position.set(2, LAND_TOP + 0.02, -44);
  clubLawn.receiveShadow = true;
  g.add(clubLawn);

  const seabed = new THREE.Mesh(new THREE.PlaneGeometry(130, 120), mats.wetSand);
  seabed.rotation.x = -Math.PI / 2;
  seabed.position.set(2, WORLD.seabed, 12);
  seabed.receiveShadow = true;
  g.add(seabed);

  const caustics = new THREE.Mesh(new THREE.PlaneGeometry(120, 110), mats.caustics);
  caustics.rotation.x = -Math.PI / 2;
  caustics.position.set(2, WORLD.seabed + 0.05, 12);
  caustics.name = "caustics";
  g.add(caustics);

  addRocks(g, mats);
  return g;
}

function addRocks(parent: THREE.Group, mats: ClubMaterials): void {
  const rng = (n: number) => {
    const x = Math.sin(n * 127.1) * 43758.5453;
    return x - Math.floor(x);
  };
  const geo = new THREE.DodecahedronGeometry(1, 0);
  let placed = 0;
  for (let i = 0; i < 80 && placed < 36; i++) {
    const x = -20 + rng(i) * 56;
    const z = 48 + rng(i + 9) * 36;
    const d = harbourWaterSdf(x, z);
    if (d > 5 || d < -1.2) continue;
    const rock = new THREE.Mesh(geo, mats.rock);
    const s = 0.6 + rng(i * 3) * 1.5;
    rock.position.set(x, 0.15, z);
    rock.scale.set(s, s * (0.5 + rng(i) * 0.7), s * 0.95);
    rock.rotation.set(rng(i) * 2, rng(i + 4) * 4, rng(i + 8));
    rock.castShadow = true;
    rock.receiveShadow = true;
    parent.add(rock);
    placed += 1;
  }

  for (const [x, z] of [
    [-42, 8],
    [-44, 22],
    [42, -8],
    [40, 20],
  ] as const) {
    const rock = new THREE.Mesh(geo, mats.rock);
    rock.position.set(x, 0.2, z);
    rock.scale.set(1.4, 0.9, 1.6);
    parent.add(rock);
  }
}
